import AMapLoader from '@amap/amap-jsapi-loader';
import { message } from 'antd';
const MapKey = 'e642d079abe7d3970472be0ce0aca4fe';
let map = undefined;
const { reload } = window;

export function createMap(params = {}) {
  return new Promise((resolve, reject) => {
    if (!map) {
      AMapLoader.load({
        key: MapKey,                     // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0",              // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [''],               // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        map = AMap;
        resolve(map);
      }).catch(e => {
        console.log(e);
        message.error('地图加载失败',reload);
        reject(map);
      });
    }else{
      resolve(map);
    }
  });
}